import { render, staticRenderFns } from "./_TraderBlock.vue?vue&type=template&id=81d37778&scoped=true&"
import script from "./_TraderBlock.vue?vue&type=script&lang=js&"
export * from "./_TraderBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d37778",
  null
  
)

export default component.exports